import { render, staticRenderFns } from "./ToggleButtons.vue?vue&type=template&id=50ecf13a&scoped=true&"
import script from "./ToggleButtons.vue?vue&type=script&lang=js&"
export * from "./ToggleButtons.vue?vue&type=script&lang=js&"
import style0 from "./ToggleButtons.vue?vue&type=style&index=0&id=50ecf13a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50ecf13a",
  null
  
)

export default component.exports